(function () {
  'use strict';

  function initQuotePage(root) {
    if (root.getAttribute('data-q-init') === '1') return;
    root.setAttribute('data-q-init', '1');

    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-check]'));
    var hiddenField = root.querySelector('[data-check-field]');

    function sync() {
      var keys = rows
        .filter(function (r) { return r.getAttribute('aria-pressed') === 'true'; })
        .map(function (r) { return r.getAttribute('data-key'); })
        .filter(Boolean);
      if (hiddenField) hiddenField.value = keys.join(', ');
    }

    rows.forEach(function (row) {
      row.addEventListener('click', function () {
        var pressed = row.getAttribute('aria-pressed') === 'true';
        row.setAttribute('aria-pressed', String(!pressed));

        var controlsId = row.getAttribute('data-controls');
        if (controlsId) {
          var group = document.getElementById(controlsId);
          if (group) {
            group.hidden = pressed; // was pressed, now unpressed -> hide
          }
        }

        sync();
      });
    });

    sync();

    var success = root.querySelector('[data-form-success]');
    if (success) {
      success.scrollIntoView({ behavior: 'smooth', block: 'start' });
      success.focus({ preventScroll: true });
    }

    initQuoteUploads(root);
  }

  function initQuoteUploads(root) {
    var fileInput = root.querySelector('[data-upload-input]');
    var form = root.querySelector('form');
    if (!fileInput || !form) return;

    var endpoint = (root.getAttribute('data-upload-endpoint') || '').replace(/\/$/, '');
    var siteKey = root.getAttribute('data-turnstile-site-key');
    if (!endpoint || !siteKey) return;

    var ALLOWED_EXTENSIONS = ['stl', 'step', 'stp', '3mf', 'obj', 'iges', 'igs', 'zip', 'pdf', 'jpg', 'jpeg', 'png', 'svg', 'dxf', 'ai', 'eps', 'tif', 'tiff', 'webp'];
    var MAX_FILES = 5;
    var MAX_SIZE = 100 * 1024 * 1024;

    var linksField = root.querySelector('[data-upload-links]');
    var fileListEl = root.querySelector('[data-upload-filelist]');
    var statusEl = root.querySelector('[data-upload-status]');
    var submitBtn = root.querySelector('[data-upload-submit]');
    var progressWrap = root.querySelector('[data-upload-progress]');
    var progressBar = root.querySelector('[data-upload-progress-bar]');
    var uploading = false;

    // Remember what already uploaded this page load, so a retry after a
    // failed send does not re-upload the same files.
    var lastUploadSig = null;
    var lastUploadUrls = [];
    function fileSig(files) {
      return files.map(function (f) { return f.name + ':' + f.size + ':' + f.lastModified; }).join('|');
    }

    // Park the form's action on a dead end permanently: third-party scripts
    // (e.g. Shopify's spam protection) that force-submit the form post
    // harmlessly to the page itself. The real send happens below via fetch,
    // never via form navigation — so Shopify's raw error page (
    // "Something went wrong / invalid parameters") is unreachable and every
    // failure surfaces as our own inline message with the form intact.
    form.setAttribute('action', window.location.pathname + '#');
    async function sanctionedSubmit() {
      var params = new URLSearchParams(new FormData(form));
      var res = await fetch('/contact', {
        method: 'POST',
        body: params,
        headers: { Accept: 'text/html' },
        redirect: 'follow',
      });
      if (res.url && res.url.indexOf('contact_posted=true') !== -1) {
        window.location.assign(res.url);
        return;
      }
      throw new Error("Shopify's automated security check blocked this submission, so nothing was sent. This usually happens after several attempts in a short time from the same connection, and the block can last a few hours. Your details and files are still filled in below. You can try again later, or submit from a different device or network. Files that already uploaded will not upload again.");
    }

    // The theme customizer re-renders sections via AJAX after Turnstile's
    // api.js has already done its one-time page scan, so a fresh widget
    // container would stay empty. Render it explicitly in that case.
    var widgetEl = root.querySelector('[data-turnstile-widget]');
    var widgetId = null;
    function ensureWidget() {
      if (widgetId === null && widgetEl && !widgetEl.hasChildNodes() && window.turnstile && window.turnstile.render) {
        // response-field false: never inject the cf-turnstile-response hidden
        // input — Shopify's own spam protection claims that field name on
        // /contact posts and rejects tokens that aren't its own.
        widgetId = window.turnstile.render(widgetEl, { sitekey: siteKey, 'response-field': false });
      }
    }
    ensureWidget();

    function resetWidget() {
      if (window.turnstile && window.turnstile.reset) {
        try {
          if (widgetId !== null) window.turnstile.reset(widgetId);
          else window.turnstile.reset();
        } catch (e) { /* widget not rendered yet */ }
      }
    }

    // Turnstile tokens are single-use. When the browser restores this page
    // from the back/forward cache, the widget still holds a spent token and
    // the next submit would fail verification — reset to get a fresh one.
    window.addEventListener('pageshow', function (ev) {
      if (ev.persisted) {
        resetWidget();
        setStatus('');
        uploading = false;
        if (submitBtn) submitBtn.disabled = false;
      }
    });

    fileInput.addEventListener('change', function () {
      if (!fileListEl) return;
      fileListEl.innerHTML = '';
      var files = Array.prototype.slice.call(fileInput.files || []);
      if (!files.length) {
        fileListEl.hidden = true;
        return;
      }
      fileListEl.hidden = false;
      files.forEach(function (f) {
        var li = document.createElement('li');
        li.textContent = f.name + ' (' + Math.round(f.size / 1024 / 1024 * 10) / 10 + 'MB)';
        fileListEl.appendChild(li);
      });
    });

    function setStatus(message, isError) {
      if (!statusEl) return;
      statusEl.textContent = message || '';
      statusEl.classList.toggle('upload-status--error', !!isError);
    }

    function validateFiles(files) {
      if (files.length > MAX_FILES) {
        throw new Error('Please attach at most ' + MAX_FILES + ' files.');
      }
      for (var i = 0; i < files.length; i++) {
        var f = files[i];
        var ext = (f.name.split('.').pop() || '').toLowerCase();
        if (ALLOWED_EXTENSIONS.indexOf(ext) === -1) {
          throw new Error('"' + f.name + '" isn\'t a supported file type.');
        }
        if (f.size > MAX_SIZE) {
          throw new Error('"' + f.name + '" is over the 100MB per-file limit. Tip: zip your files and upload the archive instead.');
        }
      }
    }

    async function requestTicket() {
      if (typeof window.turnstile === 'undefined') {
        throw new Error('The verification widget failed to load. Try refreshing the page.');
      }
      ensureWidget();
      var token = widgetId !== null ? window.turnstile.getResponse(widgetId) : window.turnstile.getResponse();
      if (!token) {
        throw new Error('Please complete the verification check above the submit button.');
      }
      var res = await fetch(endpoint + '/session', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: token }),
      });
      if (!res.ok) {
        var errBody = await res.json().catch(function () { return {}; });
        throw new Error(errBody.error || 'Verification failed.');
      }
      var data = await res.json();
      return data.ticket;
    }

    // XMLHttpRequest instead of fetch: fetch has no upload progress events.
    function uploadFile(file, ticket, onProgress) {
      return new Promise(function (resolve, reject) {
        var url = endpoint + '/upload?ticket=' + encodeURIComponent(ticket) + '&filename=' + encodeURIComponent(file.name);
        var xhr = new XMLHttpRequest();
        xhr.open('PUT', url);
        xhr.setRequestHeader('Content-Type', file.type || 'application/octet-stream');
        xhr.upload.onprogress = function (ev) {
          if (ev.lengthComputable && onProgress) onProgress(ev.loaded, ev.total);
        };
        xhr.onload = function () {
          var data = {};
          try { data = JSON.parse(xhr.responseText); } catch (e) { /* non-JSON error body */ }
          if (xhr.status >= 200 && xhr.status < 300 && data.url) {
            if (onProgress) onProgress(file.size, file.size);
            resolve(data.url);
          } else {
            reject(new Error(data.error || ('Upload failed for "' + file.name + '".')));
          }
        };
        xhr.onerror = function () { reject(new Error('Network error uploading "' + file.name + '". Check your connection and try again.')); };
        xhr.send(file);
      });
    }

    form.addEventListener('submit', function (e) {
      // Turnstile is configured on this form, so every submission — with or
      // without files — must pass verification. The browser must never
      // submit on its own; only form.submit() after verification (and any
      // uploads) succeeded. A repeat click or Enter press mid-flight would
      // fall through to default otherwise.
      e.preventDefault();
      if (uploading) return;
      uploading = true;
      if (submitBtn) submitBtn.disabled = true;

      var files = Array.prototype.slice.call(fileInput.files || []);

      (async function () {
        try {
          validateFiles(files);
          setStatus('Verifying…');
          var ticket = await requestTicket();

          var urls = [];
          if (files.length && lastUploadSig === fileSig(files) && lastUploadUrls.length === files.length) {
            urls = lastUploadUrls; // same files already uploaded this page load
          } else if (files.length) {
            var totalBytes = files.reduce(function (sum, f) { return sum + f.size; }, 0);
            var doneBytes = 0;
            if (progressWrap) {
              progressWrap.hidden = false;
              if (progressBar) progressBar.style.width = '0%';
            }
            for (var i = 0; i < files.length; i++) {
              var label = 'Uploading ' + files[i].name + ' (' + (i + 1) + ' of ' + files.length + ')';
              setStatus(label + '… 0%');
              urls.push(await uploadFile(files[i], ticket, function (loaded, total) {
                var overall = totalBytes ? Math.min(100, Math.round(((doneBytes + loaded) / totalBytes) * 100)) : 0;
                if (progressBar) progressBar.style.width = overall + '%';
                setStatus(label + '… ' + Math.round((loaded / total) * 100) + '%');
              }));
              doneBytes += files[i].size;
            }
            if (progressWrap) progressWrap.hidden = true;
            lastUploadSig = fileSig(files);
            lastUploadUrls = urls;
          }

          if (linksField && urls.length) linksField.value = urls.join(', ');
          setStatus(urls.length ? 'Files uploaded, sending your request…' : 'Verified, sending your request…');
          await sanctionedSubmit();
          // navigation to the success page is underway; stay locked
        } catch (err) {
          var msg = err.message || 'Something went wrong uploading your files.';
          if (msg.indexOf('nothing was sent') === -1 && msg.indexOf('Nothing was sent') === -1) {
            msg += ' Nothing was sent. Fix the issue and press send again.';
          }
          setStatus(msg, true);
          uploading = false;
          if (submitBtn) submitBtn.disabled = false;
          if (progressWrap) progressWrap.hidden = true;
          // Turnstile tokens are single-use; a failed attempt leaves a stale
          // token that would fail verification again on retry.
          resetWidget();
        }
      })();
    });
  }

  function initCompare(root) {
    if (root.getAttribute('data-c-init') === '1') return;
    root.setAttribute('data-c-init', '1');

    var mid = root.querySelector('[data-compare-mid]');
    var right = root.querySelector('[data-compare-right]');
    var handles = Array.prototype.slice.call(root.querySelectorAll('[data-compare-handle]'));
    if (!mid || !handles.length) return; // needs at least two images to compare

    var twoHandles = !!right && handles.length > 1;
    // pane boundaries as percentages; h1 splits left/middle, h2 middle/right
    var h1 = twoHandles ? 33 : 50;
    var h2 = 66;
    var auto = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var idleTimer = null;
    var speed = parseFloat(root.getAttribute('data-compare-speed')) || 1;
    var blendFrom = null; // easing back into the shared clock after a drag

    function render() {
      mid.style.clipPath = 'inset(0 0 0 ' + h1 + '%)';
      if (right) right.style.clipPath = 'inset(0 0 0 ' + h2 + '%)';
      if (handles[0]) handles[0].style.left = h1 + '%';
      if (twoHandles && handles[1]) handles[1].style.left = h2 + '%';
    }

    // Every compare tile derives its sweep from the same page clock, so
    // tiles with equal speed settings move in lockstep, including after a
    // user drag: on resume they ease back onto the shared clock.
    function clockTargets(nowMs) {
      var s = (Math.sin((nowMs / 1000) * 0.66 * speed) + 1) / 2;
      if (twoHandles) return { t1: 8 + s * 47, t2: 45 + s * 47 };
      return { t1: 10 + s * 80, t2: h2 };
    }

    function tick(nowMs) {
      if (auto) {
        var t = clockTargets(nowMs);
        if (blendFrom) {
          var k = Math.min(1, (nowMs - blendFrom.start) / 900);
          k = k * k * (3 - 2 * k); // smoothstep, no visible jump on resync
          h1 = blendFrom.h1 + (t.t1 - blendFrom.h1) * k;
          h2 = blendFrom.h2 + (t.t2 - blendFrom.h2) * k;
          if (k >= 1) blendFrom = null;
        } else {
          h1 = t.t1;
          h2 = t.t2;
        }
        render();
      }
      requestAnimationFrame(tick);
    }

    function pauseAuto() {
      auto = false;
      if (idleTimer) clearTimeout(idleTimer);
      idleTimer = setTimeout(function () {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        blendFrom = { h1: h1, h2: h2, start: performance.now() };
        auto = true;
      }, 4000);
    }

    var dragging = null;
    function posToPercent(clientX) {
      var rect = root.getBoundingClientRect();
      return Math.min(98, Math.max(2, ((clientX - rect.left) / rect.width) * 100));
    }
    root.addEventListener('pointerdown', function (e) {
      pauseAuto();
      var p = posToPercent(e.clientX);
      if (twoHandles) {
        dragging = Math.abs(p - h1) <= Math.abs(p - h2) ? 1 : 2;
      } else {
        dragging = 1;
      }
      root.setPointerCapture(e.pointerId);
      e.preventDefault();
    });
    root.addEventListener('pointermove', function (e) {
      if (dragging === null) return;
      pauseAuto();
      var p = posToPercent(e.clientX);
      if (dragging === 1) h1 = p;
      else h2 = p;
      render();
    });
    root.addEventListener('pointerup', function () { dragging = null; });
    root.addEventListener('pointercancel', function () { dragging = null; });

    render();
    requestAnimationFrame(tick);
  }

  function initNavToggle(header) {
    var toggle = header.querySelector('.nav-toggle');
    var menu = header.querySelector('.mobile-menu');
    if (!toggle || !menu) return;

    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      toggle.setAttribute('aria-label', expanded ? 'Open menu' : 'Close menu');
      menu.hidden = expanded;
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth > 820 && toggle.getAttribute('aria-expanded') === 'true') {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Open menu');
        menu.hidden = true;
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-quote-page]').forEach(initQuotePage);
    document.querySelectorAll('[data-compare]').forEach(initCompare);
    document.querySelectorAll('.site-header').forEach(initNavToggle);
  });

  // Theme customizer re-renders sections via AJAX; re-attach behavior when it does.
  document.addEventListener('shopify:section:load', function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll('[data-quote-page]'), initQuotePage);
    Array.prototype.forEach.call(e.target.querySelectorAll('[data-compare]'), initCompare);
  });
})();
